module.exports = __webpack_public_path__ + "media/applause.4b43f874.mp3";